<template>
  <div class="w-100 h-100 overflow-auto medical-devices-page">
    <d-medical-devices-history :id="id" :device-name="deviceName" />
  </div>
</template>

<script>

export default {
  name: 'MedicalDevicesHistoryPage',
  page: {
    title: 'CRM Doctis - История мониторингов прибора',
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    deviceName: {
      type: String,
      default: '',
    },
  },
};
</script>
